import { colors } from "constants/colors";

type CircularProgressProps = {
  value: number;
  size?: number;
  strokeWidth?: number;
  trackColor?: string;
  progressColor?: string;

  hideLabel?: boolean;
};

const clamp = (value: number) => Math.max(0, Math.min(100, value));

export const CircularProgress = ({
  value,
  size = 36,
  strokeWidth = 3,
  trackColor = colors.neutral[10],
  progressColor = colors.purple.DEFAULT,
  hideLabel = false,
}: CircularProgressProps) => {
  const safeValue = clamp(value);
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (safeValue / 100) * circumference;
  const center = size / 2;

  return (
    <div
      className="t-relative t-flex t-shrink-0 t-items-center t-justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} className="-t-rotate-90">
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={trackColor}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={progressColor}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      {!hideLabel && (
        <span className="t-absolute t-text-[8px] t-font-semibold t-text-purple">
          {safeValue}%
        </span>
      )}
    </div>
  );
};
